import React from 'react'
import PropTypes from 'prop-types'
import { Nav, Drawer, DrawerContent } from 'components/qstrap'
import { branch } from 'baobab-react/higher-order'
import intl from 'react-intl-universal'
import triggerEvent from 'utils/dataLayer'
import MobileMenuItem from 'components/header/MobileMenuItem'

const MobileMenu = ({ drawerId, currentUser }) => {
  const userName = currentUser ? currentUser.name : intl.get('guest')

  return (
    <Drawer drawerId={drawerId}>
      <DrawerContent>
        <Nav>
          {currentUser &&
            <MobileMenuItem
              icon="/assets/img/avatar.png"
              text={userName}
              href="/profile"
              onClick={() => triggerEvent('ga/global/button-navbar/profile')}
            />
          }
          {!currentUser &&
            <MobileMenuItem
              icon="title-login"
              href="/signin"
              text={intl.get('login')}
              onClick={() => triggerEvent('ga/global/button-navbar/signin')}
            />
          }
          {!currentUser &&
            <MobileMenuItem
              icon="campus-add-account"
              href="/signup"
              text={intl.get('sign_up')}
              onClick={() => triggerEvent('ga/global/button-navbar/signup')}
            />
          }
          <MobileMenuItem
            icon="nav-home"
            href="/"
            text={intl.get('home')}
            onClick={() => triggerEvent('ga/global/button-navbar/home')}
          />
          {currentUser &&
            <MobileMenuItem
              icon="campus-love"
              href="/likes/schools"
              text={intl.get('favorite')}
              onClick={() => triggerEvent('ga/global/button-navbar/favourite')}
            />
          }
          <MobileMenuItem
            icon="jyuken"
            href="/directory"
            text={intl.get('campus')}
            onClick={() => triggerEvent('ga/global/button-navbar/campus')}
          />
          <MobileMenuItem
            icon="common-course"
            href="/majors"
            text={intl.get('navs.majors')}
            onClick={() => triggerEvent('ga/global/button-navbar/major')}
          />
          <MobileMenuItem
            icon="campus-business"
            href="/careers"
            text="Karier"
            onClick={() => triggerEvent('ga/global/button-navbar/career')}
          />
          <MobileMenuItem
            icon="scholarship"
            href="/scholarships"
            text="Beasiswa"
            onClick={() => triggerEvent('ga/global/button-navbar/scholarship')}
          />
          <MobileMenuItem
            icon="title-assessment"
            href="/tests"
            text="Uji Potensi"
            onClick={() => triggerEvent('ga/global/button-navbar/test')}
          />
          <MobileMenuItem
            icon="paperplane"
            href="/peluang-sbmptn"
            text="Cek Peluang"
            onClick={() => triggerEvent('ga/global/button-navbar/prediction')}
          />
          <MobileMenuItem
            icon="campus-partner"
            href="/partners"
            text={intl.get('partners')}
            onClick={() => triggerEvent('ga/global/button-navbar/partner')}
          />
          {currentUser &&
            <MobileMenuItem
              icon="star"
              href="/recommended-campus"
              text="Kampus Rekomendasi"
              onClick={() => triggerEvent('ga/global/button-navbar/interest')}
            />
          }
          {currentUser &&
            <MobileMenuItem
              icon="campus-assessment-history"
              href="/aptitude_test/history"
              text={intl.get('aptitude.result.history.nav_link')}
              onClick={() => triggerEvent('ga/global/button-navbar/history')}
            />
          }
          {currentUser &&
            <MobileMenuItem
              icon="nav-learn"
              href="https://learn.quipper.com/id/dashboard?utm_source=QCampus&utm_medium=referral&utm_campaign=QCtoQLearn&utm_term=jul19&utm_content=qc_profile"
              text="Belajar"
              onClick={() => triggerEvent('ga/global/button-navbar/learn')}
            />
          }
          {currentUser &&
            <MobileMenuItem
              icon="nav-logout"
              href="/logout"
              text={intl.get('logout')}
              onClick={() => triggerEvent('ga/global/button-navbar/logout')}
            />
          }
        </Nav>
      </DrawerContent>
      <style jsx global>
        {`
          .drawer-header {
            display: block !important;
          }
        `}
      </style>
    </Drawer>
  )
}

MobileMenu.propTypes = {
  drawerId: PropTypes.string.isRequired,
}

export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, MobileMenu)
